import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { ecsApi } from '@services';
import { authSlice } from '@features/auth';
import { preferredValuesSlice } from '@features/preferredValues';
import { companySlice } from '@features/company';

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['api']
};

const rootReducer = combineReducers({
    authentication: authSlice.reducer,
    preferredValues: preferredValuesSlice.reducer,
    company: companySlice.reducer,
    [ecsApi.reducerPath]: ecsApi.reducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
            }
        }).concat(ecsApi.middleware)
});

export type AppStore = typeof store;

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
